export const mockNotification = [
  {
    id: 5,
    title_en: 'Annual Science Contest',
    title_th: 'การแข่งขันวิทยาศาสตร์ประจำปี',
    description_en: 'A contest for showcasing scientific projects.',
    description_th: 'การแข่งขันสำหรับแสดงผลงานวิทยาศาสตร์',
    international: true,
    registration_date: '2024-12-31T00:00:00.000Z',
    age_min: 18,
    age_max: 35,
    prize_type: 'Scholarship',
    prize_value: 5000,
    online: false,
    capacity: 100,
    prize_details: 'Full scholarship for the winner.',
    created_timestamp: '2024-11-18T13:30:33.000Z',
    edited_timestamp: '2024-11-18T13:31:37.000Z',
    category_id: 1,
    educational_level_id: 2,
    organizer_id: 2,
    publisher_id: 1,
    region_id: 4,
    approved: true,
    category: {
      id: 1,
      name_en: 'Art',
      name_th: 'ศิลปะ',
    },
    educationalLevel: {
      id: 2,
      name: 'Lower Secondary School',
    },
    organizer: {
      id: 2,
      name: 'Wat Ling Kob International',
      logo: {
        type: 'Buffer',
        data: [
          66, 97, 115, 101, 54, 52, 69, 110, 99, 111, 100, 101, 100, 73, 109,
          97, 103, 101, 83, 116, 114, 105, 110, 103,
        ],
      },
      contact_person: 'Call me plz',
      contact_phone: '123-456-7890',
      contact_email: 'contact@example.com',
      contact_line: 'contactlineid',
      contact_website: 'https://www.organizerwebsite.com',
      social_media:
        '{"facebook": "https://facebook.com/organizer", "twitter": "https://twitter.com/organizer"}',
    },
    publisher: {
      id: 1,
      username: 'johndoe',
      name_en: 'Siwat',
    },
    region: {
      id: 4,
      name: 'Eastern Thailand',
    },
    universities: [
      {
        id: 1,
        name: 'Chulalongkorn University',
      },
    ],
  },
  {
    id: 7,
    title_en: 'Annual Science Contest',
    title_th: 'การแข่งขันวิทยาศาสตร์ประจำปี',
    description_en: 'A contest for showcasing scientific projects.',
    description_th: 'การแข่งขันสำหรับแสดงผลงานวิทยาศาสตร์',
    international: true,
    registration_date: '2024-12-31T00:00:00.000Z',
    age_min: 18,
    age_max: 35,
    prize_type: 'Scholarship',
    prize_value: 5000,
    online: false,
    capacity: 100,
    prize_details: 'Full scholarship for the winner.',
    created_timestamp: '2024-11-18T14:31:08.000Z',
    edited_timestamp: '2024-11-18T14:31:46.000Z',
    category_id: 1,
    educational_level_id: 2,
    organizer_id: 2,
    publisher_id: 1,
    region_id: 4,
    approved: true,
    category: {
      id: 1,
      name_en: 'Art',
      name_th: 'ศิลปะ',
    },
    educationalLevel: {
      id: 2,
      name: 'Lower Secondary School',
    },
    organizer: {
      id: 2,
      name: 'Wat Ling Kob International',
      logo: {
        type: 'Buffer',
        data: [
          66, 97, 115, 101, 54, 52, 69, 110, 99, 111, 100, 101, 100, 73, 109,
          97, 103, 101, 83, 116, 114, 105, 110, 103,
        ],
      },
      contact_person: 'Call me plz',
      contact_phone: '123-456-7890',
      contact_email: 'contact@example.com',
      contact_line: 'contactlineid',
      contact_website: 'https://www.organizerwebsite.com',
      social_media:
        '{"facebook": "https://facebook.com/organizer", "twitter": "https://twitter.com/organizer"}',
    },
    publisher: {
      id: 1,
      username: 'johndoe',
      name_en: 'Siwat',
    },
    region: {
      id: 4,
      name: 'Eastern Thailand',
    },
    universities: [
      {
        id: 1,
        name: 'Chulalongkorn University',
      },
    ],
  },
]
